<template>
    <div class="row" :class="[question.layout === 'vertical' ? 'vertical' : 'horizontal']">
        <div :class="[question.layout === 'vertical' ? 'col-xs-6' : 'col-xs-12']">
            <slot></slot>
        </div>
        <div class="trivia-options" :class="[question.layout === 'vertical' ? 'col-xs-6' : 'col-xs-12']">
            <div
                v-for="option in question.options"
                :key="option.id"
                @click="selectOption(option.id)"
                class="card"
                :class="{ selected: isSelected(option.id) }"
            >
                <p class="trivia-option-text" v-html="option.text" @click="handleOptionClick"></p>
                <div
                    v-if="questionAnswered"
                    class="option-indicator"
                    :class="{ correct: isCorrect(option.id) }"
                >
                    <check
                        v-if="isCorrect(option.id)"
                        class="svg-icon large"
                    ></check>
                    <incorrect
                        v-if="!isCorrect(option.id) && isSelected(option.id)"
                        class="svg-icon large"
                    ></incorrect>
                </div>
            </div>

            <div v-if="multiple && !questionAnswered" class="col-xs-12 trivia-submit">
                <button
                    class="btn primary-btn"
                    :disabled="selectedOptions.length === 0"
                    @click="submit"
                >
                    {{ $t("CONTINUE") }}
                </button>
            </div>
        </div>
    </div>
</template>
<!----------------------------------------------------------------------------->
<script>
import Check from "Components/Svg/Check";
import Incorrect from "Components/Svg/Incorrect";
import triviaOptionImageLightbox from "src/mixins/triviaOptionImageLightbox";

export default {
  name: "TriviaChoice",

  mixins: [triviaOptionImageLightbox],

  components: { Check, Incorrect },

  props: {
    question: { type: Object, required: true },
    questionAnswered: { type: Boolean, required: true },
    correct: { default: null },
    multiple: { type: Boolean, default: false },
  },

  data() {
    return {
      selectedOptions: [],
    };
  },

  methods: {
    isSelected(optionId) {
      return this.selectedOptions.includes(optionId);
    },

    isCorrect(optionId) {
      return this.multiple
        ? this.correct && this.correct.includes(optionId)
        : optionId === this.correct;
    },

    selectOption(optionId) {
      if (this.questionAnswered) return;

      if (this.multiple) {
        const idx = this.selectedOptions.indexOf(optionId);
        if (idx === -1) {
          this.selectedOptions.push(optionId);
        } else {
          this.selectedOptions.splice(idx, 1);
        }
      } else {
        if (this.selectedOptions[0] === optionId) {
          this.selectedOptions = [];
        } else {
          this.selectedOptions = [optionId];
          this.$emit("answer", optionId);
        }
      }
    },

    submit() {
      if (this.selectedOptions.length === 0) return;
      this.$emit("answer", [...this.selectedOptions]);
    },
  },
};
</script>
<!----------------------------------------------------------------------------->
<style lang="scss" type="text/scss">
.trivia-option-text img {
    max-width: 100%;
    height: auto;
    cursor: zoom-in;
}
</style>
